import { gql, TypedDocumentNode } from '@apollo/client';

import {
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables,
} from '../generated';

export const UPDATE_USER_PROFILE: TypedDocumentNode<
  UpdateUserProfileMutation,
  UpdateUserProfileMutationVariables
> = gql`
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfile(input: $input) {
      id
      email
      displayName
      settings {
        aiAssistEditChatModel
        colorMode
      }
      effectiveAiAssistEditChatModel
    }
  }
`;
